var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.templateList.length > 0
    ? _c(
        "div",
        { staticClass: "grid-container" },
        _vm._l(_vm.templateList, function (item) {
          return _c(
            "div",
            { key: item.id, staticClass: "grid-item" },
            [
              _c(
                "div",
                { staticClass: "grid-item-content" },
                [
                  _c("div", { staticClass: "title" }, [
                    _c("div", { staticClass: "name" }, [
                      _vm._v(" " + _vm._s(item.name || "— —") + " "),
                    ]),
                    _vm.rename
                      ? _c("i", {
                          staticClass: "el-icon el-icon-edit",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.changeName(item)
                            },
                          },
                        })
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "img",
                      on: {
                        click: function ($event) {
                          return _vm.selectTemp(item)
                        },
                      },
                    },
                    [
                      _c("el-image", { attrs: { src: item.thumb } }, [
                        _c(
                          "div",
                          {
                            staticClass: "loading",
                            attrs: { slot: "placeholder" },
                            slot: "placeholder",
                          },
                          [_vm._v("加载中...")]
                        ),
                      ]),
                      _vm.showHandle
                        ? _c(
                            "div",
                            {
                              class: [
                                "handle",
                                _vm.source === "channel" && "channel",
                              ],
                            },
                            [
                              _vm._l(_vm.handleList, function (h) {
                                return [
                                  h.show(item)
                                    ? _c(
                                        "div",
                                        {
                                          key: h.type,
                                          staticClass: "btn",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return h.onHandle(item)
                                            },
                                          },
                                        },
                                        [_vm._v(" " + _vm._s(h.label) + " ")]
                                      )
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.showHandle && _vm.source === "channel"
                    ? _c(
                        "div",
                        { staticClass: "handle2-wrap" },
                        [
                          _c(
                            "el-link",
                            {
                              directives: [
                                {
                                  name: "has",
                                  rawName: "v-has",
                                  value:
                                    "/decoration/template/copy-channel-template-platform",
                                  expression:
                                    "'/decoration/template/copy-channel-template-platform'",
                                },
                              ],
                              attrs: { type: "warning" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.chooseToPlatform(item)
                                },
                              },
                            },
                            [_vm._v("选为平台模板")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._t("handle", null, { temp: item }),
                ],
                2
              ),
              _vm._t("btns", null, { temp: item }),
            ],
            2
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }